import React, { Fragment } from 'react';
import { func, bool, object, array } from 'prop-types';

import { EMAIL } from '../../utils/regexp';

import {
  FormS,
  AddEmailButton,
  InputS,
  IconS,
  ListEmailsWrapper,
  EmailRow,
  EmailValue,
  RemoveEmailButton,
  EmailValueWrapper,
  FormItemS,
  DividerS,
  CountriesList,
  EmailRowWrapper,
} from './styled-components';
import { Title } from '../styled-components';
import { theme } from '../../styles';
import { USER_ROLES } from '../../api/constants';

const { ADMIN, SUPER_ADMIN } = USER_ROLES;

const ManageEmailsModalComp = ({
  form: { getFieldDecorator },
  emails,
  isFetching,
  onAddNewEmail,
  onDeleteEmail,
  isHardcoded,
  authUser,
}) => (
  <Fragment>
    <Title>Add Emails to notify people</Title>
    {[ADMIN, SUPER_ADMIN].includes(authUser.role) && (
      <Fragment>
        <FormS onSubmit={onAddNewEmail}>
          <FormItemS>
            {getFieldDecorator('email', {
              rules: [
                {
                  pattern: EMAIL,
                  required: true,
                  message: 'The input is not valid Email!',
                },
              ],
            })(<InputS
              prefix={<IconS type="message" size={21} color={theme.colors.backgroundSilver} />}
              placeholder="Enter client name"
              size="large"
              name="email"
            />)}
          </FormItemS>
          <AddEmailButton isLoading={isFetching} disabled={isFetching}>
            + Add
          </AddEmailButton>
        </FormS>
        <DividerS />
      </Fragment>
    )}
    <ListEmailsWrapper>
      {emails.map(({ _id, email, onlyForCountries = [] }) => (
        <EmailRowWrapper key={_id}>
          <EmailRow>
            <EmailValueWrapper>
              <EmailValue>
                {email}
              </EmailValue>
            </EmailValueWrapper>
            {[ADMIN, SUPER_ADMIN].includes(authUser.role) && (
              <RemoveEmailButton
                disabled={isHardcoded(onlyForCountries)}
                onClick={() => onDeleteEmail(_id)}
              >
                Remove
              </RemoveEmailButton>
            )}
          </EmailRow>
          {isHardcoded(onlyForCountries) ?
            <CountriesList>
              <span>Responsible for countries:</span> {onlyForCountries.join(', ')}
            </CountriesList>
            : null }
        </EmailRowWrapper>
      ))}
    </ListEmailsWrapper>
  </Fragment>
);

ManageEmailsModalComp.propTypes = {
  isFetching: bool.isRequired,
  onAddNewEmail: func.isRequired,
  onDeleteEmail: func.isRequired,
  isHardcoded: func.isRequired,
  form: object.isRequired,
  emails: array.isRequired,
  authUser: object.isRequired,
};

export default ManageEmailsModalComp;



// WEBPACK FOOTER //
// ./src/modals/manage-emails-modal/manage-emails-modal-comp.js